import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WordList } from '@thiememeulenhoff/types';
import { WordListEndpointService } from './wordlist.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class WordListService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(WordListEndpointService);

  fetchWordLists(contentIdentifier: string) {
    if (!contentIdentifier || contentIdentifier === '') {
      throw new Error('contentId is required for fetching word lists');
    }

    return this.#http.get<Array<WordList>>(this.#endpoints.wordLists(), {
      params: { contentId: contentIdentifier },
    });
  }
}
